import * as React from 'react'
import { Elements } from '@tfo/common'
import { useIntl } from 'react-intl'

const { Paragraph } = Elements

const NoBackgroundCheck = () => {
    const intl = useIntl()

    return (
        <div className='NoBackgroundCheck'>
            <Paragraph bold>
                {intl.formatMessage(
                    { id: 'individual.noBackgroundCheck.welcome' }
                )}
            </Paragraph>
            <Paragraph>
                {intl.formatMessage(
                    { id: 'individual.noBackgroundCheck.body' }
                )}
            </Paragraph>
        </div>
    )
}

export default NoBackgroundCheck